import * as React from 'react';
import classnames from 'classnames';
import Flex, { Props as FlexProps } from '../Flex/Flex';
import './ColorButton.css';

export interface Props extends FlexProps {
  /** Color of the button */
  color: 'blue' | 'grape' | 'green' | 'red' | 'white' | 'yellow';
  /**
   * Sets the size of the Button. Small allows the Button to fit
   * into smaller spaces, while large will help the button stand
   * out on a page with lots of space.
   */
  size: 'small' | 'medium' | 'large';
}

/**
 *
 */
const ColorButton: React.FunctionComponent<Props> = (props: Props) => {
  const {
    color,
    size,
    ...rest
  } = props;

  const classes = classnames('ColorButton',
    `ColorButton--color-${color}`,
    `ColorButton--size-${size}`);

  return (
    <Flex Component="button" { ...rest }
        alignChildren="middle"
        className={ classes }
        direction="horizontal"
        gap="x1" />
  );
};

export default ColorButton;
